import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { FormattedMessage } from "react-intl";
import TextField from "@material-ui/core/TextField";

import { ThemeProvider } from "@material-ui/styles";
import { createTheme, Typography } from "@material-ui/core";
import "./time.css";

const materialTheme = createTheme({
    overrides: {
        MuiTextField: {
            root: {
                height: 44,
                fontFamily: "Arial",
                fontSize: 10,
                backgroundColor: "var(--grey-background)",
                color: "var(--text-dark)",
                borderRadius: "2px 2px 0px 0px",
            },
        },

        MuiInput: {
            root: {
                paddingLeft: "8px",
            },
        },

        MuiInputLabel: {
            root: {
                marginLeft: "8px",
                marginTop: "4px",
            },
        },
    },
});

export const Time = ({ time: initTime, onChange, label }, ref) => {
    const currentInitTime = typeof initTime === "number" ? new Date(initTime) : initTime;
    const [internalTime, setInternalTime] = useState(currentInitTime ? currentInitTime : new Date());
    const [minutes, setMinutes] = useState(currentInitTime ? currentInitTime.getMinutes() : 0);
    const [hour, setHour] = useState(currentInitTime ? currentInitTime.getHours() : 0);
    const prevTimer = React.useRef(initTime);

    // update the minutes and hours state values when the current time property changes
    useEffect(() => {
        if (prevTimer.current !== initTime) {
            setInternalTime(currentInitTime ? currentInitTime : new Date());
            setMinutes(currentInitTime ? currentInitTime.getMinutes() : 0);
            setHour(currentInitTime ? currentInitTime.getHours() : 0);
        }
    }, [currentInitTime, initTime]);

    useImperativeHandle(ref, () => ({
        setTime: (newTime) => {
            setInternalTime(newTime);
            setMinutes(newTime.getMinutes());
            setHour(newTime.getHours());
        },
    }));

    const updateMinutes = (mins) => {
        mins = mins % 60;
        if (mins === -1) {
            mins = 59;
        }
        const newTime = new Date(internalTime.setMinutes(mins));
        setMinutes(mins);
        onChange(newTime);
    };

    const updateHour = (hour) => {
        hour = hour % 24;
        if (hour === -1) {
            hour = 23;
        }
        const newTime = new Date(internalTime.setHours(hour));
        setHour(hour);
        onChange(newTime);
    };

    return (
        <React.Fragment>
            <ThemeProvider theme={materialTheme}>
                <Typography
                    style={{
                        paddingLeft: "24px",
                    }}>
                    {label}
                </Typography>
                <div className="timelayout">
                    <TextField
                        label={<FormattedMessage id="select-date-time.hour" defaultMessage="Hour" description="Hour label" />}
                        type="number"
                        inputProps={{ role: "Hours" }}
                        value={hour}
                        onChange={(e) => updateHour(e.target.value)}
                    />

                    <div className="timeseparator">
                        <span>:</span>
                    </div>

                    <TextField
                        label={<FormattedMessage id="select-date-time.minutes" defaultMessage="Minutes" description="Minutes label" />}
                        type="number"
                        inputProps={{ role: "Minutes" }}
                        value={minutes}
                        onChange={(e) => updateMinutes(e.target.value)}
                    />
                </div>
            </ThemeProvider>
        </React.Fragment>
    );
};

export default forwardRef(Time);
